<template>
  <div class="page_three" >
    <div class="page_two_title flex-eju-center">
      <div class="title_word">
        营销赋能
        <div class="line_block"></div>
      </div>
    </div>
    <div class="list_wrapper flex-eju-center">
      <div
        class="list_item animate__animated"
        :class="[activeItem === item.title ? 'active' : '', item.animate]"
        v-for="(item, index) in listData"
        :key="index"
        @click="chooseItem(item.title, index)"
      >
        <div class="item_title">
          <div
            class="title_icon flex-eju-center"
            :style="`background-image:url(${
              activeItem === item.title ? item.bgActive : item.bg
            })`"
          >
            <img
              :src="activeItem === item.title ? item.iconActive : item.icon"
            />
          </div>
          <div class="title_word">{{ item.title }}</div>
        </div>
        <div class="item_content">{{ item.content }}</div>
      </div>
    </div>
    <div class="banner_list" :style="`height:${calcListHeight()}px`">
      <div class="banner_wrapper animate__animated animate__fadeInUp" :style="`left: ${bannerLeft}px`">
        <div
          class="banner_item"
          :class="[index !== bannerIndex ? 'is_gray' : '']"
          v-for="(ban, index) in bannerData"
          :key="index"
        >
          <div class="img img1" :style="`background-image:url(${ban[0]})`"></div>
          <div class="img img2" :style="`background-image:url(${ban[1]})`"></div>
          <div class="img img3" :style="`background-image:url(${ban[2]})`"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activePageIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    activePageIndex: {
      handler: function(val) {
        if (val === 2) {
          this.showPage = true;
        }
      },
    }
  },
  mounted() {
    this.chooseItem('裂变拓客', 2)
  },
  data() {
    return {
      showPage: false,
      activeItem: "活码设置",
      bannerIndex: 0,
      bannerLeft: -20,
      bannerData: [
        [
          require("@/assets/svg/page_3/1-活码设置-01.png"),
          require("@/assets/svg/page_3/1-活码设置-02.png"),
          require("@/assets/svg/page_3/1-活码设置-03.png"),
        ],
        [
          require("@/assets/svg/page_3/2-楼盘小程序-01.png"),
          require("@/assets/svg/page_3/2-楼盘小程序-02.png"),
          require("@/assets/svg/page_3/2-楼盘小程序-03.png"),
        ],
        [
          require("@/assets/svg/page_3/3-裂变拓客-01.png"), 
          require("@/assets/svg/page_3/3-裂变拓客-02.png"),
          require("@/assets/svg/page_3/3-裂变拓客-03.png"),
        ],
        [
          require("@/assets/svg/page_3/5-营销互动-01.png"),
          require("@/assets/svg/page_3/5-营销互动-02.png"),
          require("@/assets/svg/page_3/5-营销互动-03.png"),
        ],
        [
          require("@/assets/svg/page_3/4-道具中心-01.png"),
          require("@/assets/svg/page_3/4-道具中心-02.png"),
          require("@/assets/svg/page_3/4-道具中心-03.png"),
        ]
      ],
      listData: [
        {
          title: "活码设置",
          icon: require("@/assets/svg/page_3/二维码.svg"),
          iconActive: require("@/assets/svg/page_3/二维码-active.svg"),
          bg: require("@/assets/svg/page_3/图标背景.svg"),
          bgActive: require("@/assets/svg/page_3/图标背景-active.svg"),
          content:
            "基于场景与活动的名片二维码设置，识别客户来源，建立客户标签，为精准的客户画像和运营做好铺垫。",
          animate: "animate__fadeInDown",
        },
        {
          title: "楼盘小程序",
          icon: require("@/assets/svg/page_3/小程序.svg"),
          iconActive: require("@/assets/svg/page_3/小程序-active.svg"),
          bg: require("@/assets/svg/page_3/图标背景.svg"),
          bgActive: require("@/assets/svg/page_3/图标背景-active.svg"),
          content:
            "自定义专属线上售楼处，互动式内容传播，建立客户与楼盘连接，一键电话、一键分享，扩大传播力，多平台传播打通线上线下。",
          animate: "animate__fadeInDown",
        },
        {
          title: "裂变拓客",
          icon: require("@/assets/svg/page_3/渠道.svg"),
          iconActive: require("@/assets/svg/page_3/渠道-active.svg"),
          bg: require("@/assets/svg/page_3/图标背景.svg"),
          bgActive: require("@/assets/svg/page_3/图标背景-active.svg"),
          content:
            "互联网轻量级高效获客方式，奖励驱动客户自发拉新，实现客户指数级增长，玩法多样，如：新人红包、助力任务、到访奖励等等。",
          animate: "animate__fadeInDown",
        },
        {
          title: "营销互动",
          icon: require("@/assets/svg/page_3/直播.svg"),
          iconActive: require("@/assets/svg/page_3/直播-active.svg"),
          bg: require("@/assets/svg/page_3/图标背景.svg"),
          bgActive: require("@/assets/svg/page_3/图标背景-active.svg"),
          content:
            "案场直播-开盘活动，营销动作直接触达，后台数据监测，客户意向分析；同屏互动-集成VR带看，远程讲解，随时随地看房，营销地点、时间无限制",
          animate: "animate__fadeInDown",
        },
        {
          title: "道具中心",
          icon: require("@/assets/svg/page_3/工具.svg"),
          iconActive: require("@/assets/svg/page_3/工具-active.svg"),
          bg: require("@/assets/svg/page_3/图标背景.svg"),
          bgActive: require("@/assets/svg/page_3/图标背景-active.svg"),
          content:
            "房地产专属素材库，统一内容制作，丰富场景模板，效果监控反馈，定期发送反复触达。",
          animate: "animate__fadeInDown",
        }
      ],
    };
  },
  methods: {
    chooseItem(title, index) {
      if (this.activeItem === title) return;
      this.activeItem = title;
      this.bannerIndex = index;
      this.bannerLeft = -1 * index * 980 - 20;
    },
    calcListHeight() {
      let allHeight = window.innerHeight;
      let height = (allHeight - allHeight*0.08 - 120 - 168) * 0.9;
      return height > 692 ? 692 : height;
    }
  },
};
</script>
<style lang="less" scoped>
.page_three {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 8%;
  position: relative;
  overflow: hidden;
  &::before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/svg/chart-bg-deep.svg");
    background-size: 100%;
    background-position: center;
    opacity: 0.05;
  }
  .page_two_title {
    font-weight: 300;
    font-size: 40px;
    line-height: 56px;
    color: #212538;
    margin-bottom: 48px;
    .title_word {
      position: relative;
      padding-bottom: 16px;
      .line_block {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(105.88deg, #007aff 0%, #0057ff 100%);
        border-radius: 4px;
      }
    }
  }
  .list_item {
    height: 168px;
    width: 224px;
    border-bottom: 2px solid rgba(34, 34, 34, 0.1);
    box-sizing: border-box;
    margin: 0 15px;
    position: relative;
    cursor: pointer;
    .item_title {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 12px;
      .title_icon {
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-right: 8px;
        img {
          width: 24px;
          height: 24px;
        }
        .title_word {
          font-weight: 700;
          font-size: 20px;
          color: #212538;
        }
      }
    }
    .item_content {
      font-size: 14px;
      line-height: 20px;
      color: rgba(33, 37, 56, 0.7);
    }
    &.active {
      border-color: #007aff;
    }
  }
  .banner_list {
    position: absolute;
    left: 50%;
    bottom: 0;
    // height: 500px;
    width: 940px;
    transform: translateX(-50%);
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background: none;
    }
    .banner_wrapper {
      height: 100%;
      position: relative;
      top: 0;
      display: flex;
      justify-content: flex-start;
      transition: all .3s;
      .banner_item {
        display: flex;
        width: auto;
        height: 100%;
        transition: all .3s;
        opacity: 1;
        margin: 0 20px;
        &.is_gray {
          // filter: grayscale(100%); 
          // filter: gray;
          opacity: 0;
          // opacity: 0.5;
          height: 80%;
          transform: translateY(20%);
        }
        .img {
          margin: 0 30px;
          background-size: 100%;
          background-repeat: no-repeat;
        }
        .img1 {
          width: 240px;
          border-radius: 8px;
          position: relative;
          transform: translateY(86px);
          box-shadow: 0 0px 20px 0px rgba(34, 34, 34, .1);
        }
        .img2 {
          width: 280px;
          border-radius: 12px;
          box-shadow: 0 0px 20px 0px rgba(34, 34, 34, .1);
        }
        .img3 {
          width: 240px;
          border-radius: 8px;
          position: relative;
          transform: translateY(86px);
          box-shadow: 0 0px 20px 0px rgba(34, 34, 34, .1);
        }
      }
    }
  }
}
</style>
